function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { assign, Machine, sendParent, spawn } from 'xstate';
import { inputMachine } from '../inputMachine';

//todo add other types state , events etc to machine
export const inputGroupMachine = services => Machine({
  id: 'input-group-machine',
  context: {
    data: undefined,
    initialData: undefined
  },
  type: 'parallel',
  states: {
    pristine: {
      initial: 'pristine',
      states: {
        pristine: {
          on: {
            INPUT: 'dirty',
            SET: 'dirty'
          }
        },
        dirty: {
          on: {
            REINITIALISE: 'pristine'
          }
        }
      }
    },
    active: {
      initial: "initializing",
      on: {
        REINITIALISE: '.reinitializing'
      },
      states: {
        initializing: {
          entry: 'spawnInputs',
          on: {
            '': 'ready'
          }
        },
        reinitializing: {
          entry: ['setData', 'updateInputs'],
          on: {
            '': 'ready'
          }
        },
        ready: {
          initial: 'initialized',
          on: {
            INPUT: {
              actions: ['setValue'],
              target: '.validating'
            },
            SET: '.setting'
          },
          states: {
            initialized: {
              on: {
                '': [{
                  target: "validating",
                  cond: ctx => ctx.validateOnInitialise
                }, {
                  target: "valid",
                  cond: ctx => !ctx.validateOnInitialise
                }]
              }
            },
            setting: {
              entry: ['setData', 'updateInputs'],
              on: {
                '': {
                  target: 'validating'
                }
              }
            },
            valid: {
              entry: 'clearInputErrorMessages'
            },
            inValid: {},
            validating: {
              invoke: {
                id: "validating",
                src: 'onValidation',
                onDone: "comitting",
                onError: {
                  target: "raisingError"
                }
              }
            },
            comitting: {
              entry: ['sendValueToParent'],
              invoke: {
                id: 'handleChange',
                src: 'onChange',
                onDone: {
                  target: 'valid'
                }
              }
            },
            raisingError: {
              entry: 'sendInputErrorMessages',
              invoke: {
                id: 'handleError',
                src: 'onValidationError',
                onDone: {
                  target: 'inValid'
                }
              }
            }
          }
        }
      }
    }
  }
}, {
  actions: {
    spawnInputs: assign(ctx => {
      if (ctx.inputList) {
        let inputRefs = {};
        ctx.inputList.forEach(key => {
          const input = inputMachine();
          if (ctx.data) {
            var _ctx$data$key;
            inputRefs[key] = spawn(input.withContext(_objectSpread(_objectSpread({}, input.context), {
              name: key,
              value: (_ctx$data$key = ctx.data[key]) !== null && _ctx$data$key !== void 0 ? _ctx$data$key : undefined
            })), key);
          }
        });
        ctx.inputRefs = inputRefs;
      }
      return ctx;
    }),
    sendInputErrorMessages: (ctx, e) => {
      if (ctx.inputRefs) {
        Object.keys(ctx.inputRefs).forEach(name => {
          const errorMessage = e.data ? e.data[name] || undefined : undefined;
          if (ctx.inputRefs) {
            ctx.inputRefs[name].send({
              errorMessage,
              type: errorMessage ? "SET_INVALID" : "SET_VALID"
            });
          }
        });
      }
    },
    clearInputErrorMessages: ctx => {
      if (ctx.inputRefs) {
        Object.keys(ctx.inputRefs).forEach(name => {
          if (ctx.inputRefs) {
            ctx.inputRefs[name].send('SET_VALID');
          }
        });
      }
    },
    setValue: assign((ctx, e) => {
      if (ctx.data) {
        //todo type the event and get rid of cast
        //use immer?
        const updated = _objectSpread({}, ctx.data);
        updated[e.name] = e.value;
        ctx.data = updated;
      }
      return ctx;
    }),
    setData: assign((ctx, e) => {
      //use immer
      if (e.type === 'REINITIALISE') {
        ctx.initialData = _objectSpread({}, e.value);
      }
      ctx.data = _objectSpread({}, e.value);
      return ctx;
    }),
    updateInputs: ctx => {
      if (ctx.inputRefs) {
        Object.keys(ctx.inputRefs).forEach(name => {
          if (ctx.data) {
            ctx.inputRefs[name].send({
              value: ctx.data[name],
              type: "SET"
            });
          }
        });
      }
    },
    sendValueToParent: ctx => {
      sendParent({
        type: 'INPUT',
        value: ctx.data
      });
    }
  },
  services
});